import type { SkillCatalogItem } from '@/services/skillApi'

/**
 * Match catalog item với skill id (vd. ba-domain-analysis).
 * Ưu tiên slug/name khớp; fallback contains.
 */
export function findCatalogBySkillKey(
  items: SkillCatalogItem[],
  skillKey: string
): SkillCatalogItem | undefined {
  const q = skillKey.trim().toLowerCase()
  if (!q) return undefined

  const exact = items.find(
    (i) => i.slug.toLowerCase() === q || i.name.toLowerCase() === q
  )
  if (exact) return exact

  const scored = items
    .map((i) => {
      const slug = i.slug.toLowerCase()
      const name = i.name.toLowerCase()
      const group = (i.groupPath || '').toLowerCase()
      const hay = `${slug} ${name} ${group}`
      let score = 0
      if (slug.includes(q) || q.includes(slug)) score += 3
      if (name.includes(q) || q.includes(name)) score += 2
      if (group.includes(q) || group.endsWith(`/${q}`)) score += 2
      if (hay.includes(q)) score += 1
      return { i, score }
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)

  return scored[0]?.i
}

/** Deep-link tới thư viện: public → detail; không khớp / private → search */
export function skillLibraryPath(
  skillId: string,
  items?: SkillCatalogItem[] | null
): string {
  const id = skillId.trim()
  if (!id) return '/skills'
  if (items?.length) {
    const hit = findCatalogBySkillKey(items, id)
    if (hit?.isPublic) return `/skills/${hit.id}`
  }
  return `/skills?skill=${encodeURIComponent(id)}`
}
